import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { CardImage } from '@/features/product-card';
import { Toman } from '@/components/svg-symbols/icons';
import { toNumberCommas } from '@/utils/string-helpers';
import { getCdnUrl } from '@/utils/url';
import StarsSvg from './stars-svg';
interface Props {
  name: string;
  brand: string;
  basePrice: number;
  salesPrice: number;
  discountPercent: number;
  image: string;
  isLazy: boolean;
}
export const BlackProductCard = ({
  name,
  brand,
  basePrice,
  salesPrice,
  discountPercent,
  image,
  isLazy
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const imageSize = isMobile ? 144 : 219;
  return <div className='relative flex h-full w-36 flex-col overflow-hidden rounded-b-lg bg-neutral-900 lg:w-[219px]' data-sentry-component="BlackProductCard" data-sentry-source-file="black-product-card.tsx">
            <div className='relative flex grow flex-col gap-1 rounded-t-lg border border-b-0 border-neutral-700 px-1.5 pb-1 pt-1.5 lg:pb-3'>
                <div className='relative overflow-hidden rounded-lg'>
                    <span className='absolute right-0 top-0 rounded-ee-lg bg-primary-main px-1.5 py-0.5 text-caption-12 font-medium text-text-white lg:text-body-14'>
                        {discountPercent}٪
                    </span>
                    <CardImage alt={name} image={getCdnUrl(image)} srcSet={{
          desktop: 130,
          mobile: 175
        }} isLazy={isLazy} imageClassName='aspect-square h-auto' width={imageSize} height={imageSize} data-sentry-element="CardImage" data-sentry-source-file="black-product-card.tsx" />
                </div>

                <span className='text-caption-12 text-text-lightGray'>{brand}</span>

                <h3 className='line-clamp-2 grow text-caption-12 text-text-white lg:text-body-14'>{name}</h3>

                <StarsSvg className='absolute -bottom-1 left-1.5' data-sentry-element="StarsSvg" data-sentry-source-file="black-product-card.tsx" />
            </div>

            <div className='z-10 grid grid-cols-2 text-caption-12 lg:text-body-14'>
                <div className='flex items-center justify-center bg-white py-1 text-text-darkGray line-through'>
                    {toNumberCommas(basePrice ?? 0)}
                </div>
                <div className='tex-text-white flex items-center justify-center gap-1 bg-primary-main py-1 font-medium'>
                    <span>{toNumberCommas(salesPrice ?? 0)}</span>
                    <Toman className='mb-1 h-4 w-4 text-text-white lg:h-5 lg:w-5' data-sentry-element="Toman" data-sentry-source-file="black-product-card.tsx" />
                </div>
            </div>
        </div>;
};